/* VIYAN: gate add-to-cart on the complimentary charm picker.

   Dawn's product form is novalidate and submits via fetch, so the
   selects' `required` attribute never blocks anything on its own.
   All listeners are document-level capture-phase delegation: they run
   before product-form.js's submit handler and before Shopify's
   dynamic-checkout (Buy it now) click handler, and they keep working
   if Dawn re-renders the form after a variant change.
   Wallet buttons (Shop Pay etc.) render in iframes and skip required
   validation entirely, so buy-buttons.liquid layers a transparent
   shield button over them; the shield eats clicks (and shows the
   error) until both charms are chosen, then hides itself. */
(function () {
  'use strict';

  var FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';

  function pickerComplete(picker) {
    var complete = true;
    picker.querySelectorAll('[data-viyan-charm-select]').forEach(function (select) {
      if (!select.value) complete = false;
    });
    return complete;
  }

  function charmsComplete(form) {
    var picker = form.querySelector('[data-viyan-charm-picker]');
    if (!picker) return true;
    return pickerComplete(picker);
  }

  /* Scroll-triggered notice. The strip stays hidden until the picker has
     been scrolled into view at least once, then hides itself for good as
     soon as both charms are filled. Purely a nudge: the wallet shield and
     the submit gate are what actually block checkout. */
  var noticeObserver = null;

  function updateNotice(picker) {
    var notice = picker.querySelector('[data-viyan-charm-notice]');
    if (!notice) return;
    notice.hidden = picker.dataset.viyanNoticeSeen !== '1' || pickerComplete(picker);
  }

  function watchPickers() {
    if (!('IntersectionObserver' in window)) return;
    if (!noticeObserver) {
      noticeObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.dataset.viyanNoticeSeen = '1';
            updateNotice(entry.target);
            noticeObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.25 }
      );
    }
    /* Dawn can re-render the product form on a variant change, so this
       runs again on load, pageshow and every charm change; already
       watched pickers are skipped. */
    document.querySelectorAll('[data-viyan-charm-picker]').forEach(function (picker) {
      if (picker.dataset.viyanNoticeWatched === '1') return;
      picker.dataset.viyanNoticeWatched = '1';
      noticeObserver.observe(picker);
    });
  }

  function updateShields(form) {
    var complete = charmsComplete(form);
    form.querySelectorAll('[data-viyan-wallet-shield]').forEach(function (shield) {
      shield.hidden = complete;
    });
  }

  /* bfcache restores / autofill can bring back selected values. */
  function updateAllShields() {
    document.querySelectorAll(FORM_SELECTOR).forEach(updateShields);
    watchPickers();
  }
  updateAllShields();
  window.addEventListener('pageshow', updateAllShields);

  function validate(form) {
    var picker = form.querySelector('[data-viyan-charm-picker]');
    if (!picker) return true;
    var ok = true;
    picker.querySelectorAll('[data-viyan-charm-select]').forEach(function (select) {
      var empty = !select.value;
      select.classList.toggle('viyan-charm-picker__select--error', empty);
      /* The value now lives on a hidden input, so the visible highlight
         goes on its field wrapper (see viyan-charm-tiles.js). */
      var field = select.closest('[data-viyan-charm-field]');
      if (field) field.classList.toggle('viyan-charm-picker__field--error', empty);
      if (empty) ok = false;
    });
    var error = picker.querySelector('[data-viyan-charm-error]');
    if (error) error.hidden = ok;
    if (!ok) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return ok;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches(FORM_SELECTOR)) return;
      if (!form.querySelector('[data-viyan-charm-picker]')) return;
      if (!validate(form)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  /* The shield sits on top of the wallet-button iframes: a click on it
     means charms are still missing — show the error and scroll to the
     picker. It never lets the click reach the iframe below. */
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target || !event.target.closest) return;
      var shield = event.target.closest('[data-viyan-wallet-shield]');
      if (!shield) return;
      event.preventDefault();
      event.stopPropagation();
      var form = shield.closest(FORM_SELECTOR);
      if (form) validate(form);
    },
    true
  );

  /* Buy it now never fires a submit event — gate the click instead.
     (Wallet buttons rendered inside iframes cannot be intercepted;
     the plain Buy-it-now button can.) */
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target || !event.target.closest) return;
      var button = event.target.closest(
        '.shopify-payment-button button, .shopify-payment-button [role="button"]'
      );
      if (!button) return;
      var form = button.closest(FORM_SELECTOR);
      if (!form) {
        var wrapper = button.closest('product-form');
        form = wrapper ? wrapper.querySelector(FORM_SELECTOR) : null;
      }
      if (!form || !form.querySelector('[data-viyan-charm-picker]')) return;
      if (!validate(form)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  /* Clear the error state as soon as both charms are chosen. */
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('[data-viyan-charm-select]')) return;
    if (select.value) {
      select.classList.remove('viyan-charm-picker__select--error');
      var field = select.closest('[data-viyan-charm-field]');
      if (field) field.classList.remove('viyan-charm-picker__field--error');
    }
    var picker = select.closest('[data-viyan-charm-picker]');
    if (!picker) return;
    var allSet = true;
    picker.querySelectorAll('[data-viyan-charm-select]').forEach(function (other) {
      if (!other.value) allSet = false;
    });
    if (allSet) {
      var error = picker.querySelector('[data-viyan-charm-error]');
      if (error) error.hidden = true;
    }
    updateNotice(picker);
    var form = select.closest(FORM_SELECTOR);
    if (form) updateShields(form);
    watchPickers();
  });

  /* VIYAN 2026-10-02: Clarity showed dead clicks on the "complimentary charms"
     copy (picker heading/note and the announcement bar). On a PDP, a tap there
     scrolls to the picker and opens Charm 1. Off-PDP the bar stays inert. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var inPicker = target.closest('.viyan-charm-picker__heading, .viyan-charm-picker__note');
    var bar = target.closest('.announcement-bar__message');
    if (!inPicker && !(bar && /complimentary charms/i.test(bar.textContent))) return;
    var picker = inPicker ? inPicker.closest('[data-viyan-charm-picker]') : document.querySelector('[data-viyan-charm-picker]');
    if (!picker) return;
    var slot = picker.querySelector('[data-viyan-charm-slot="1"] [data-viyan-charm-slot-button]');
    picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (slot) slot.click();
  });
})();
